module.exports = __webpack_public_path__ + "img/点检仪.38479c7c.jpg";